function removeClass( className, el ) {
  if (el.classList)
    el.classList.remove(className);
  else
    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

function addClass( classname, element ) {
  var cn = element.className;
  //test for existance
  if( cn.indexOf( classname ) != -1 ) {
    return;
  }
  //add a space if the element already has class
  if( cn != '' ) {
    classname = ' '+classname;
  }
  element.className = cn+classname;
}

function hasClass(element, className) {
  return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

/* const url = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTXPrjgkB19JzMeoIwAY-sqTWu7UBvPosAZJUAj9qH-VWxnULhzfxd3Zt9IfpsgT-exIb-oLaY0LjSp/pub?output=csv'; */
const url = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR9HqBnCjgJ88M-2xEibwgxwTLYpdwxeo5l2UCsMxUxmZgC4x67Q_gNnnI2qe_oXSIVfBedWy9QyA_C/pub?output=csv';

var map,
    geocoder,
    markerCluster,
    infoWindow = null,
    markers = [],
    infoWindows = [],
    clickers = [],
    allCategories = [],
    allCategoriesUppercase = [];


Array.prototype.flexFilter = function(info) {
  // Set our variables
  var matchesFilter, matches = [], count;

  // Helper function to loop through the filter criteria to find matching values
  // Each filter criteria is treated as "AND". So each item must match all the filter criteria to be considered a match.
  // Multiple filter values in a filter field are treated as "OR" i.e. ["Blue", "Green"] will yield items matching a value of Blue OR Green.
  matchesFilter = function(item) {
    count = 0
    for (var n = 0; n < info.length; n++) {
      if (info[n]["Values"].indexOf(item[info[n]["Field"]]) > -1) {
        count++;
      }
      //if value = all, return all item
      else if (info[n]["Values"] == "all") {
        count++;
      }
    }
    // If TRUE, then the current item in the array meets all the filter criteria
    return count == info.length;
  }

  // Loop through each item in the array
  for (var i = 0; i < this.length; i++) {
    // Determine if the current item matches the filter criteria
    if (matchesFilter(this[i])) {
      matches.push(this[i]);
    }
  }

  // Give us a new array containing the objects matching the filter criteria
  return matches;
}


function parseCSV(str) {
  console.log('DB // TEST');
  var arr = [];
  var quote = false;  // 'true' means we're inside a quoted field

  // Iterate over each character, keep track of current row and column (of the returned array)
  for (var row = 0, col = 0, c = 0; c < str.length; c++) {
    var cc = str[c], nc = str[c+1];        // Current character, next character
    arr[row] = arr[row] || [];             // Create a new row if necessary
    arr[row][col] = arr[row][col] || '';   // Create a new column (start with empty string) if necessary

    // If the current character is a quotation mark, and we're inside a
    // quoted field, and the next character is also a quotation mark,
    // add a quotation mark to the current column and skip the next character
    if (cc == '"' && quote && nc == '"') { arr[row][col] += cc; ++c; continue; }

    // If it's just one quotation mark, begin/end quoted field
    if (cc == '"') { quote = !quote; continue; }

    // If it's a comma and we're not in a quoted field, move on to the next column
    if (cc == ',' && !quote) { ++col; continue; }

    // If it's a newline (CRLF) and we're not in a quoted field, skip the next character
    // and move on to the next row and move to column 0 of that new row
    if (cc == '\r' && nc == '\n' && !quote) { ++row; col = 0; ++c; continue; }

    // If it's a newline (LF or CR) and we're not in a quoted field,
    // move on to the next row and move to column 0 of that new row
    if (cc == '\n' && !quote) { ++row; col = 0; continue; }
    if (cc == '\r' && !quote) { ++row; col = 0; continue; }

    // Otherwise, append the current character to the current column
    arr[row][col] += cc;
  }
  return arr;
}

function csvToJSON(csvData) {
  var data = csvData;
  var objData = [];
  for (var i = 1; i < data.length; i++) {
    objData[i - 1] = {};
    for (var k = 0; k < data[0].length && k < data[i].length; k++) {
      var key = data[0][k];
      objData[i - 1][key] = data[i][k]
    }
  }
  var jsonData = JSON.stringify(objData);
  jsonData = jsonData.replace(/},/g, "},\r\n");
  return JSON.parse(jsonData);
}


function initialize() {

  // Giving the map som options
  var mapOptions = {
    zoom: 2,
    center: new google.maps.LatLng(27.7540324,-54.6816677),
    mapTypeControl: false
  };

  // Creating the map
  geocoder = new google.maps.Geocoder();
  map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  var request = new XMLHttpRequest();
  request.open('GET', url, true);

  request.onload = function() {

    if (request.status >= 200 && request.status < 400) {
      // Success!
      var locations = parseCSV(request.responseText);
      var locationsJson = csvToJSON(locations);

      locations.forEach(function(location, i){
        if(i === 0) {
          return true;
        }

        var name = location[0] ? location[0] : '',
            address = location[4] ? location[4] : '',
            city = location[2] ? location[2] : '',
            state = location[7] ? location[7] : '',
            zip = location[3] ? location[3] : '',
            country = location[1] ? location[1] : '',
            lat = location[5] ? location[5] : '',
            lng = location[6] ? location[6] : '',
            website = location[9] ? location[9] : '',
            phone = location[8] ? location[8] : '',
            categories = location[10] ? location[10].split(',') : '';

        name.replace(/&/g, '&amp;');


        if(categories != '') {
          categories.forEach(function(category,i) {
            //console.log(category);
            category = category.trim();
            const categoryUpcase = category.toLowerCase();
            if(allCategoriesUppercase.includes(categoryUpcase) === false && category != '') {
              allCategories.push(category);
              allCategoriesUppercase.push(categoryUpcase);
            }
          });
        }

        //Just the first one 
        if(i==0) {
          //console.log(location);
        }

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(lat,lng),
          title: name,
          category: categories,
          snow: categories.includes('Snow') ? true : false,
          skate: categories.includes('Skate') ? true : false,
          apparel: categories.includes('Apparel') ? true : false
        });

        markers.push(marker);


        var title = '<h4>'+name+'</h4>',
            address = address + '<br/>' + city + ', ' + state + ' ' + zip;

        if(website != '') {
          address += '<br/><a target="_blank" href="'+website+'">' + website + '</a>';
        }
        if(phone != '') {
          address += '<br/>'+phone;
        }


        var contentString = '<div id="content">' + title + '<div>' + address + '</div>' + '</div>';
        infoWindows.push(contentString);


        marker.addListener('click',function() {
          //infoWindows.close
          if (infoWindow) {
            infoWindow.close();
          }

          infoWindow = new google.maps.InfoWindow({
            content: contentString
          }); 

          infoWindow.open(map,marker);
        });

      });

    } else {
      //  ERROR !
      console.log(request);
      var error = document.createElement('h3');
      error.innerHTML = request.responseText;
      error.setAttribute('id','stockist-error');
      document.querySelector('#stockists').appendChild(error);
      // We reached our target server, but it returned an error
    }
    markerCluster = new MarkerClusterer(map, markers, {imagePath: '//developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
    //console.log(allCategories);

    var categoryLinks = document.querySelectorAll('.category-select');
    var allCategoryLink = document.querySelector('.category-all');

    function fadeOutEffect(el) {
      var fadeEffect = setInterval(function () {
        if (!el.style.opacity) {
          el.style.opacity = 1;
        }
        if (el.style.opacity > 0) {
          el.style.opacity -= 0.1;
        } else {
          clearInterval(fadeEffect);
          el.style.display = 'none';
        }
      }, 50);
    }

    var preloader = document.querySelector('.map-preloader');

    fadeOutEffect(document.querySelector('.map-preloader'));


    //<a class="category category-select" href="#" data-category="Snow">Snow</a>
    allCategories.forEach(function(v,i) {
      //var $this = this;
      var a = document.createElement('a');
      a.setAttribute('href','#');
      a.setAttribute('data-category',v);
      a.className='category category-select';
      a.innerHTML = v;
      document.querySelector('.category-selectors').appendChild(a);
      //console.log(i);
      a.addEventListener('click', function(e) {

        var activeCategories = [];

        removeClass('active',allCategoryLink);

        e.preventDefault();
        var $this = this;

        if(hasClass($this,'active')) {
          removeClass('active',$this);
        } else {
          addClass('active',$this);
        }

        if(document.querySelectorAll('.category-select.active').length) {
          document.querySelectorAll('.category-select.active').forEach(function(el) {
            //removeClass('active',el);
            activeCategories.push(el.getAttribute('data-category'));
          });
          filterMarkers(activeCategories);
        } else {
          allCategoryLink.dispatchEvent(new Event('click',{ bubbles: true }));          
        }
      });
    });

    allCategoryLink.addEventListener('click',function(e) {
      e.preventDefault();
      document.querySelectorAll('.category').forEach(function(el) {
        removeClass('active',el);
      });
      addClass('active',this);
      markerCluster.clearMarkers();
      markerCluster.addMarkers(markers);
    });

    filterMarkers = function(categories) {
      var newmarkers = [];
      //checkedBoxes = ([document.querySelectorAll('input[type=checkbox]:checked')]).map(function(o) { return o.id; });

      for (i = 0; i < markers.length; i++) {
        marker = markers[i];
        if(typeof marker.category == 'object' && categories.every(function (o) {
          console.log(o);
          return (marker.category).indexOf(o) >= 0;})){
          marker.setVisible(true);
          newmarkers.push(marker);
        } else {
          marker.setVisible(false);
        }

      }
      markerCluster.clearMarkers();
      markerCluster.addMarkers(newmarkers);
    }


  };

  request.onerror = function(a,b,c) {
    console.log(a);
    // There was a connection error of some sort
  };

  request.send();   
}
function codeAddress() {
  var address = document.querySelector('#address').value;
  geocoder.geocode( { 'address': address}, function(results, status) {
    if (status == 'OK') {
      map.setCenter(results[0].geometry.location);
      if (results[0].geometry.viewport)
        map.fitBounds(results[0].geometry.viewport);
      /*
      var marker = new google.maps.Marker({
        map: map,
        position: results[0].geometry.location
      });
      */
    } else {
      alert('Geocode was not successful for the following reason: ' + status);
    }
  });
}

// Initialize the map
google.maps.event.addDomListener(window, 'load', initialize);
console.log('DB // RAN');